import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Application } from '../../models/interfaces';
import Message from '../../components/ui/Message';
import { ApplicationsContext } from '../../context/applications/ApplicationContext';
import { TreeNodeModel } from '../../components/tree/types';
import { AuthContext } from '../../context/auth';


export const ApplicationsPage = () => {

    const navigate = useNavigate();

    const { applications, loadApplications, deleteRequest, isLoading, getClient, addApplication } = useContext(ApplicationsContext);

    const [activeTab, setActiveTab] = useState<'draft' | 'clients'>('draft');

    // Draft search
    const [buscar, setBuscar] = useState('');

    // Existing clients filters
    const [registrationNumber, setRegistrationNumber] = useState('');
    const [merchantId, setMerchantId] = useState('');
    const [clientNumber, setClientNumber] = useState('');
    const [terminalId, setTerminalId] = useState('');
    const [clients, setClients] = useState<Application[]>([]);
    const [loadingClients, setLoadingClients] = useState(false);

    // Messages
    const [errorMessage, setErrorMessage] = useState('');
    const [rejectMessage, setRejectMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [successTitle, setSuccessTitle] = useState('Exitoso');

    const [currentApp, setCurrentApp] = useState(0);

    const { user } = useContext(AuthContext);
    const isUserPayfac = user.groups[0].is_payfac_group == 'Y';

    useEffect(() => {
        loadApps();
    }, [user]);

    const loadApps = () => {
        if (isUserPayfac) {
            loadApplications(['DRAFT_PAYFAC']);
        } else {
            loadApplications(['DRAFT', 'REJECTED', 'PENDING_OFFICER']);
        }
    };

    useEffect(() => {
        if (activeTab === 'clients') {
            setRegistrationNumber('');
            setMerchantId('');
            setClientNumber('');
            setTerminalId('');
            setClients([]);
        }
    }, [activeTab]);

    const filteredData = applications.filter((app: Application) =>
        app.BUSINESS_NAME.toLowerCase().includes(buscar.toLowerCase()) ||
        app.MERCHANT_RUC.toLowerCase().includes(buscar.toLowerCase())
    );

    const handleNew = () => {
        navigate('/merchant');
    };

    const handleEdit = async (application: Application, existent: boolean = false) => {

        if (existent) {



            const [resp, entityId] = await addApplication(application.payload, false);

            if (resp !== "success") {
                setErrorMessage(resp);
                return;
            } else {
                application.APP_ID = parseInt(entityId);
            }
        }
        navigate('/merchant', { state: { application } });
    };

    const handleView = async (application: Application, existent: boolean = false) => {
        setSuccessTitle('Observaciones')
        if (application.REJECTION_REASON == null || application.REJECTION_REASON == '') {
            setSuccessMessage('No hay observaciones');
        } else {

            setSuccessMessage(application.REJECTION_REASON);
        }
    };



    const handleDelete = async (appId: number) => {
        setCurrentApp(appId);
        setRejectMessage("¿Confirma que desea eliminar esta solicitud?");
    };

    const removeSuccessMessage = () => {
        setSuccessMessage(''); setSuccessTitle('Observaciones');
    }
    const removeError = () => setErrorMessage('');
    const removeRejectMessage = () => setRejectMessage('');

    const rejDecRequest = async (reason: string) => {
        removeRejectMessage();
        let resp = await deleteRequest(currentApp.toString(), reason);

        if (resp === 'success') {
            setSuccessMessage("La solicitud se eliminó correctamente.");
            loadApps();
        } else {
            setErrorMessage(resp);
        }
    };

    const handleFilterClient = async () => {

        if (!registrationNumber && !clientNumber && !merchantId && !terminalId) {
            setErrorMessage('Debe ingresar al menos un criterio de búsqueda.');
            return;
        }

        setLoadingClients(true);

        try {
            const resp = await getClient({
                registrationNumber,
                clientNumber,
                merchantId,
                terminalId
            });

            if (resp) {
                setClients(Array.isArray(resp) ? resp : [resp]);
            } else {
                setClients([]);
            }

        } catch (error) {
            setClients([]);
            setErrorMessage('Error consultando cliente.');
        }

        setLoadingClients(false);
    };

    return (
        <div className='mt-5 container'>

            {/* TABS */}
            <ul className="nav nav-tabs mt-4">
                <li className="nav-item">
                    <button
                        className={`nav-link ${activeTab === 'draft' ? 'active' : ''}`}
                        onClick={() => setActiveTab('draft')}
                    >
                        Clientes nuevos
                    </button>
                </li>
                <li className="nav-item">
                    <button
                        className={`nav-link ${activeTab === 'clients' ? 'active' : ''}`}
                        onClick={() => setActiveTab('clients')}
                    >
                        Clientes Existentes
                    </button>
                </li>
            </ul>

            {/* ================== DRAFT TAB ================== */}
            {activeTab === 'draft' && (
                <>
                    <div className="row justify-content-end mt-4">
                        <div className="col-md-3">
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Buscar"
                                value={buscar}
                                onChange={(e) => setBuscar(e.target.value)}
                            />
                        </div>

                        {!isUserPayfac && <div className="col-md-1">
                            <button
                                type="button"
                                className="btn btn-success w-100"
                                onClick={handleNew}
                            >
                                Nuevo
                            </button>
                        </div>}
                    </div>

                    <br />

                    <table className="table table-hover table-striped">
                        <thead className="thead-dark">
                            <tr>
                                <th>ID</th>
                                <th>Banco</th>
                                <th>Número Id Fiscal</th>
                                <th>Nombre Comercial</th>
                                {/* <th>Contacto</th>
                                <th>Email</th> */}
                                <th>Estado</th>
                                <th>Creado</th>
                                <th>Creado por</th>
                                <th style={{ textAlign: 'center' }}>Acciones</th>
                            </tr>
                        </thead>

                        <tbody>
                            {
                                filteredData.length > 0
                                    ? filteredData.map((app: Application) => (
                                        <tr key={app.APP_ID}>
                                            <td>{app.APP_ID}</td>
                                            <td>{app.BANK_CODE}</td>
                                            <td>{app.MERCHANT_RUC}</td>
                                            <td>{app.BUSINESS_NAME}</td>
                                            {/*
                                            <td>{app.CONTACT_PERSON}</td> 
                                            <td>{app.CONTACT_EMAIL ?? '-'}</td>*/}
                                            <td>{getStatus(app)}</td>
                                            <td>{new Date(app.CREATED_AT).toLocaleDateString()}</td>
                                            <td>{app.CREATED_BY}</td>
                                            <td style={{ textAlign: 'center' }}>
                                                <div className="dropdown">
                                                    <button
                                                        className="btn btn-secondary dropdown-toggle"
                                                        type="button"
                                                        data-bs-toggle="dropdown"
                                                        aria-expanded="false"
                                                    >
                                                        <span className='bi bi-list'></span>
                                                    </button>

                                                    <ul className="dropdown-menu">
                                                        <li>
                                                            <button
                                                                className="dropdown-item text-secondary"
                                                                onClick={() => handleView(app)}
                                                            >
                                                                <i className="bi bi-eye me-2"></i>
                                                                Observaciones
                                                            </button>
                                                        </li>
                                                        <li>
                                                            <hr className="dropdown-divider" />
                                                        </li>
                                                        <li>
                                                            <button
                                                                className="dropdown-item text-success"
                                                                onClick={() => handleEdit(app)}
                                                            >
                                                                <i className="bi bi-pencil me-2"></i>
                                                                Editar
                                                            </button>
                                                        </li>

                                                        <li>
                                                            <hr className="dropdown-divider" />
                                                        </li>

                                                        <li>
                                                            <button
                                                                className="dropdown-item text-danger"
                                                                onClick={() => handleDelete(app.APP_ID)}
                                                            >
                                                                <i className="bi bi-trash me-2"></i>
                                                                Eliminar
                                                            </button>
                                                        </li>
                                                    </ul>
                                                </div>

                                            </td>
                                            {/* <td style={{ textAlign: 'center' }}>
                                                <button
                                                    className="btn btn-sm btn-primary"
                                                    onClick={() => handleEdit(app)}
                                                >
                                                    Editar
                                                </button>
                                                <button
                                                    className="btn btn-sm btn-danger ms-2"
                                                    onClick={() => handleDelete(app.APP_ID)}
                                                >
                                                    Eliminar
                                                </button>
                                            </td> */}
                                        </tr>
                                    ))
                                    : (
                                        <tr>
                                            <td colSpan={9} className="text-center">
                                                {isLoading ? 'Cargando...' : 'No existen aplicaciones.'}
                                            </td>
                                        </tr>
                                    )
                            }
                        </tbody>
                    </table>
                </>
            )}

            {/* ================== CLIENTS TAB ================== */}
            {activeTab === 'clients' && (
                <>
                    <div className="row mt-4">
                        <div className="col-md-3">
                            <input
                                className="form-control"
                                placeholder="Número Id Fiscal"
                                value={registrationNumber}
                                onChange={(e) => setRegistrationNumber(e.target.value)}
                            />
                        </div>

                        {!isUserPayfac && <div className="col-md-3">
                            <input
                                className="form-control"
                                placeholder="Número de cliente"
                                value={clientNumber}
                                onChange={(e) => setClientNumber(e.target.value)}
                            />
                        </div>}

                        {<div className="col-md-3">
                            <input
                                className="form-control"
                                placeholder="Número de comercio (Merchant ID)"
                                value={merchantId}
                                onChange={(e) => setMerchantId(e.target.value)}
                            />
                        </div>}

                        {!isUserPayfac && <div className="col-md-3">
                            <input
                                className="form-control"
                                placeholder="Número de terminal"
                                value={terminalId}
                                onChange={(e) => setTerminalId(e.target.value)}
                            />
                        </div>}

                        {isUserPayfac && <div className="col-md-2 ">
                            <button
                                className="btn btn-primary w-100"
                                onClick={handleFilterClient}
                            >
                                Filtrar
                            </button>
                        </div>}


                    </div>
                    {!isUserPayfac && <div className="row mt-3 justify-content-end">
                        <div className="col-md-3 ">
                            <button
                                className="btn btn-primary w-100"
                                onClick={handleFilterClient}
                            >
                                Filtrar
                            </button>
                        </div>

                    </div>}
                    {user.isLafise && <div style={{ marginTop: '15px' }}>
                        <p style={{ marginBottom: '0' }}><b>Importante:</b> En comercios PAYFAC o con más de 10 tiendas, la búsqueda por Número de Afiliado o Número de Cliente solo permitirá crear <b>nuevas tiendas</b>. </p>
                        <p>Para agregar terminales a un comercio existente, utilice la búsqueda por Merchant ID o el Número de Terminal.</p>
                    </div>}

                    <hr />
                    <div className="mt-4">
                        <table className="table table-hover table-striped">
                            <thead className="thead-dark">
                                <tr>
                                    {/* <th># Solicitud</th> */}
                                    <th>Número Id Fiscal</th>
                                    <th>Nombre Comercial</th>
                                    {/* <th>Contacto</th>
                                    <th>Email</th> */}
                                    <th style={{ textAlign: 'center' }}>Acciones</th>
                                </tr>
                            </thead>

                            <tbody>
                                {loadingClients ? (
                                    <tr>
                                        <td colSpan={5} className="text-center">
                                            Cargando...
                                        </td>
                                    </tr>
                                ) : clients.length > 0 ? (
                                    clients.map((client) => (
                                        <tr key={client.APP_ID}>
                                            {/* <td>{client.APP_ID}</td> */}
                                            <td>{client.MERCHANT_RUC}</td>
                                            <td>{client.BUSINESS_NAME}</td>
                                            {/* <td>{client.CONTACT_PERSON}</td>
                                            <td>{client.CONTACT_EMAIL ?? '-'}</td> */}
                                            <td style={{ textAlign: 'center' }}>
                                                <button
                                                    className="btn btn-sm btn-primary"
                                                    onClick={() => handleEdit(client, true)}
                                                >
                                                    Editar
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={5} className="text-center">
                                            No existen resultados.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                </>
            )}

            {/* MENSAJES */}
            {errorMessage && (
                <Message
                    type="error"
                    message={errorMessage}
                    closeDialog={removeError}
                    handleOk={removeError}
                />
            )}

            {rejectMessage && (
                <Message
                    type="success"
                    title="Confirme"
                    message={rejectMessage}
                    closeDialog={removeRejectMessage}
                    handleOk={rejDecRequest}
                    showReasonField={true}
                    backgroundColor="rgba(0,0,0,0.4)"
                />
            )}

            {successMessage && (
                <Message
                    type="success"
                    title={successTitle}
                    message={successMessage}
                    closeDialog={removeSuccessMessage}
                    handleOk={removeSuccessMessage}
                    backgroundColor="rgba(0,0,0,0.4)"
                />
            )}
        </div>
    );
};

function getStatus(app: Application): string {
    switch (app.STATUS) {
        case "DRAFT": return "Borrador";
        case "PENDING": return "Pendiente";
        case "APPROVED": return "Aprobado";
        case "REJECTED": return "Rechazado";
        case "ERROR": return "Procesado con error";
        case "DECLINED": return "Eliminada";
        case "DRAFT_PAYFAC": return "Borrador";
        case "REJECTED_PF": return "Rechazado";
        case "PENDING_OFFICER": return "Revision banco";
        default: return "";
    }
}